<script setup lang="ts">
import { Popup } from "vant";
import DownloadIcon from "@/components/icon/DownloadIcon.vue";
import PlayIcon from "@/components/icon/playIcon.vue";
import ScreenshotSharePopup, {
  ScreenshotSharePopupExpose,
} from "@/components/mobile/popup/ScreenshotSharePopup.vue";
import MagicStickIcon from "@/components/icon/MagicStickIcon.vue";
import { Story } from "@/types/entity";
import { useStory } from "@/stores/story";
import { useRouter } from "vue-router";
import { ref } from "vue";

const props = defineProps<{
  story?: Story;
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();

const storyStore = useStory();
const router = useRouter();
const screenshotSharePopupRef = ref<ScreenshotSharePopupExpose | null>(null);
const onScreenshotClick = async () => {
  emit("update:show", false);
  await screenshotSharePopupRef.value?.startGenerateScreenshot();
};
</script>
<template>
  <popup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="center"
    class="w-[350px] py-10"
    round
    teleport="body"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-4">
      <div class="flex flex-col items-center justify-center gap-2">
        <download-icon class="icon-2xl" />
        <div class="text-lg font-bold">
          {{ $t("story.selectTheTypeChapterDownload") }}
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="onScreenshotClick"
        >
          <magic-stick-icon class="icon-base" />
          {{ $t("story.image") }}
        </button>
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="
            router.push({
              name: 'videoGeneration',
              query: {
                storyUuid: story!.uuid,
              },
            })
          "
        >
          <play-icon />
          {{ $t("story.video") }}
        </button>
        <button
          class="btn w-60 rounded btn-sm"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.close") }}
        </button>
      </div>
    </div>
  </popup>
  <screenshot-share-popup
    ref="screenshotSharePopupRef"
    :on-screenshot-generate="() => storyStore.storyScreenshot(story!.uuid)"
  />
</template>
